"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validate = exports.errorMessages = exports["default"] = exports.NAME_MAX_LENGTH = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reduxForm = require("redux-form");
var _cccisdReduxFormHelpers = require("cccisd-redux-form-helpers");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var NAME_MAX_LENGTH = exports.NAME_MAX_LENGTH = 20;
var errorMessages = exports.errorMessages = {
  required: 'Name is required',
  length: "No more than ".concat(NAME_MAX_LENGTH, " characters"),
  regex: 'Accepts only letters, numbers, spaces and dashes'
};
var validate = exports.validate = function validate(values) {
  var errors = {};
  if (!values.userName) {
    errors.userName = errorMessages.required;
  } else if (values.userName.length > NAME_MAX_LENGTH) {
    errors.userName = errorMessages.length;
  } else if (!/^[\w- ]+$/.test(values.userName)) {
    errors.userName = errorMessages.regex;
  }
  return errors;
};
var Picker = /*#__PURE__*/function (_React$Component) {
  function Picker() {
    var _this;
    _classCallCheck(this, Picker);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Picker, [].concat(args));
    _defineProperty(_this, "handleChange", function () {
      if (_this.props.valid) {
        _this.props.fields.changed.onChange(true);
      }
    });
    _defineProperty(_this, "render", function () {
      var DataConnectorsPicker = _this.props.DataConnectorsPicker;
      return /*#__PURE__*/_react["default"].createElement(DataConnectorsPicker, {
        elementId: 0,
        field: _this.props.fields.variable,
        type: ['string', 'number'],
        noModal: true,
        afterChange: _this.handleChange,
        topRender: /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.FieldBlock, {
          field: _this.props.fields.userName,
          label: "Variable name"
        }, /*#__PURE__*/_react["default"].createElement("input", _extends({
          type: "text",
          className: "form-control form-control-sm"
        }, (0, _cccisdReduxFormHelpers.domOnlyProps)(_this.props.fields.userName), {
          style: {
            maxWidth: '200px'
          },
          maxLength: NAME_MAX_LENGTH,
          autoFocus: true,
          placeholder: "e.g. Student name"
        })))
      });
    });
    return _this;
  }
  _inherits(Picker, _React$Component);
  return _createClass(Picker, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var oldValue = prevProps.fields.changed.value;
      var newValue = this.props.fields.changed.value;
      if (oldValue !== newValue) {
        this.props.handleSubmit();
      }
    }
  }]);
}(_react["default"].Component);
_defineProperty(Picker, "propTypes", {
  DataConnectorsPicker: _propTypes["default"].func,
  fields: _propTypes["default"].object,
  handleSubmit: _propTypes["default"].func,
  valid: _propTypes["default"].bool
});
var _default = exports["default"] = (0, _reduxForm.reduxForm)({
  form: 'variablePicker',
  fields: ['variable', 'userName', 'changed'],
  validate: validate
})(Picker);